import EncounterAppointmentCard from './EncounterAppointmentCard';

export default EncounterAppointmentCard;
